import { render } from "./ProfileMenu.vue?vue&type=template&id=9c730da8"
import script from "./ProfileMenu.vue?vue&type=script&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&lang=js"

import "./ProfileMenu.vue?vue&type=style&index=0&id=9c730da8&lang=css"

import exportComponent from "/Users/nika/Sites/tanastsoroba-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__